import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { routes } from './app.routes';
import { AppComponent } from './app.component';
import { SearchMainComponent } from './search-main/search-main.component';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { niIcons } from './svg/ni';
import { SearchHeaderComponent } from './components/search-header/search-header.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import {
  SearchGenericComponent
} from './components/search-results/search-mashups/search-generic/search-generic.component';
import {
  SearchEntityComponent
} from './components/search-results/search-mashups/search-entity/search-entity.component';
import { RbTranslateParserService } from './shared/service/rb-translate-parser.service';
import { SearchMessageBoxComponent } from './components/search-message-box/search-message-box.component';
import { SearchResultInfoComponent } from './components/search-result-info/search-result-info.component';
import {
  SearchDataPluginComponent
} from './components/search-results/search-mashups/search-data-plugin/search-data-plugin.component';
import {
  SearchInstrumentDriverComponent
} from './components/search-results/search-mashups/search-instrument-driver/search-instrument-driver.component';
import { httpInterceptorProviders } from './shared/interceptors';
import {
  SearchPrimaryNavigationComponent
} from './components/search-primary-navigation/search-primary-navigation.component';
import { LineClampComponent } from './shared/components/line-clamp/line-clamp.component';
import {
  SearchInstrumentDriverTableComponent
} from './components/search-results/search-table-mashups/search-instrument-driver-table/search-instrument-driver-table.component';
import { NiErrorHandler } from './shared/error/ni-error-handler';
import { ResultClickTrackingDirective } from './shared/directives/result-click-tracking.directive';
import { PurchaseDirective } from './shared/directives/purchase.directive';
import {
  SecondaryNavigationDropdownFilterComponent
} from './components/search-secondary-navigation/secondary-navigation-dropdown-filter/secondary-navigation-dropdown-filter.component';
import { SearchFilterBoxComponent } from './components/search-filter-box/search-filter-box.component';
import {
  SearchSecondaryNavigationComponent
} from './components/search-secondary-navigation/search-secondary-navigation.component';
import {
  SecondaryNavigationDropdownComponent
} from './components/search-secondary-navigation/secondary-navigation-dropdown/secondary-navigation-dropdown.component';
import { ClickOutsideDirective } from './shared/directives/click-outside.directive';
import { SearchNoResultComponent } from './components/search-no-result/search-no-result.component';
import { SearchPaginationComponent } from './components/search-pagination/search-pagination.component';
import { SearchDymComponent } from './components/search-dym/search-dym.component';
import { SearchUtilityBarComponent } from './components/search-utility-bar/search-utility-bar.component';
import {
  SearchUtilityBarDropdownComponent
} from './components/search-utility-bar/search-utility-bar-dropdown/search-utility-bar-dropdown.component';
import { SearchErrorComponent } from './search-error/search-error.component';
import {
  SearchPrimaryNavigationItemComponent
} from './components/search-primary-navigation/search-primary-navigation-item/search-primary-navigation-item.component';
import {
  SearchLoadingComponent
} from './components/search-results/search-mashups/search-loading/search-loading.component';
import { SafehtmlPipe } from './shared/pipes/safehtml.pipe';
import {
  SearchEntityCtaComponent
} from './components/search-results/search-mashups/search-entity/search-entity-cta/search-entity-cta.component';
import { provideRouter, RouterOutlet } from '@angular/router';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/site-search/api/dictionary/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SearchMainComponent,
    SearchHeaderComponent,
    SearchResultsComponent,
    SearchGenericComponent,
    SearchEntityComponent,
    SearchMessageBoxComponent,
    SearchResultInfoComponent,
    SearchDataPluginComponent,
    SearchInstrumentDriverComponent,
    SearchPrimaryNavigationComponent,
    LineClampComponent,
    SearchInstrumentDriverTableComponent,
    SecondaryNavigationDropdownFilterComponent,
    ResultClickTrackingDirective,
    PurchaseDirective,
    SearchFilterBoxComponent,
    ClickOutsideDirective,
    SearchSecondaryNavigationComponent,
    SecondaryNavigationDropdownComponent,
    SearchNoResultComponent,
    SearchDymComponent,
    SearchUtilityBarComponent,
    SearchUtilityBarDropdownComponent,
    SearchPaginationComponent,
    SearchErrorComponent,
    SearchPrimaryNavigationItemComponent,
    SearchLoadingComponent,
    SafehtmlPipe,
    SearchEntityCtaComponent,
    SearchEntityCtaComponent
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule.forRoot({
      parser: { provide: TranslateParser, useClass: RbTranslateParserService },
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    SvgIconComponent,
    RouterOutlet],
  providers: [
    CookieService,
    httpInterceptorProviders,
    {
      provide: ErrorHandler,
      useClass: NiErrorHandler,
      deps: [Injector]
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideSvgIcons(niIcons),
    provideRouter(routes)
  ]
})
export class AppModule {
}
